<template>
  <div class="flex flex-between">
    <!-- 外层容器：控制显示高度 -->
    <div
      :style="{ maxHeight: flag ? offsetHeight + 'px' : height + 'px' }"
      class="outer flex1 flex flex-v-center flex-wrap"
    >
      <div ref="inner">
        <slot></slot>
      </div>
    </div>

    <!-- 展开/收起按钮 -->
    <div
      @click="flag = !flag"
      v-if="offsetHeight > height"
      style="padding: 0 10px; align-items: flex-end"
      class="st pointer flex"
    >
      <i :class="flag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "RowSpan",
  data() {
    return {
      offsetHeight: 0, // 内容真实高度
      flag: false, // 展开/收起状态
    };
  },
  props: {
    height: {
      type: Number,
      default: 84,
    },
  },
  mounted() {
    // 初始化获取真实高度
    this.$nextTick(() => {
      this.updateHeight();
    });
  },
  methods: {
    // 更新内容高度
    updateHeight() {
      const inner = this.$refs.inner;
      if (inner) {
        this.offsetHeight = inner.offsetHeight;
      }
    },
  },
  // 监听插槽内容变化，自动更新高度（解决内容变化后显示不全）
  updated() {
    this.$nextTick(() => {
      this.updateHeight();
    });
  },
};
</script>

<style scoped>
.outer {
  position: relative;
  overflow: hidden;
  /* 加过渡动画更流畅 */
  transition: max-height 0.3s ease;
}
.icon {
  color: #e6a13c;
  font-size: 20px;
  line-height: 28px;
}
</style>